import { ComponentPropsWithoutRef, ReactNode } from 'react';

import cn from '@/utils/cn';

interface TitledCardProps
  extends Omit<ComponentPropsWithoutRef<'div'>, 'title'> {
  title: ReactNode;
}

const TitledCard = ({
  title,
  children,
  className,
  ...props
}: TitledCardProps) => {
  return (
    <div
      className={cn('flex flex-col gap-3 rounded-xlg bg-white p-6', className)}
      {...props}
    >
      <p className="h3 text-oxford-blue-500">{title}</p>
      {children}
    </div>
  );
};

export default TitledCard;
